/**
 * Converts units of measurements from EP to displays
 * @param {string} type - unit of measurement
 * @returns {string} Converted measurement
 */
const abbreviateUnitOfMeasure = (type) => {
  switch (type?.toUpperCase()) {
    case 'PERCENTAGE': {
      return '%';
    }
    case 'MG':
    case 'MILLIGRAMS': {
      return 'mg';
    }
    case 'GRAMS': {
      return 'g';
    }
    case 'MILLILITERS': {
      return 'ml';
    }
    default: {
      return type;
    }
  }
};

export default abbreviateUnitOfMeasure;
